import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db, auth, requestFCMToken } from '../firebase';

/**
 * Request notification permission, get FCM token, and save to the care user document.
 */
export async function registerFCMTokenForCareUser() {
  const uid = auth?.currentUser?.uid;
  if (!uid) return null;
  const token = await requestFCMToken();
  if (!token) return null;
  try {
    const ref = doc(db, 'users', uid);
    await updateDoc(ref, {
      fcmToken: token,
      fcmTokenUpdatedAt: serverTimestamp(),
    });
    return token;
  } catch (e) {
    console.warn('Save care FCM token failed', e);
    return null;
  }
}
